import { Card, CardContent, CardActions, Avatar, Typography, Button, Stack, Chip, Box } from '@mui/material';
import Link from 'next/link';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import { readingTime } from '../../utils/helpers';
import { getRandomStr } from '../../helpers';
import { useRouter } from 'next/router';

export default function Post({ post, index }) {

  const router = useRouter()
  const convertTime12to24 = time12h => {
    const [time, modifier] = time12h?.split(' ');
    let [hours, minutes, seconds] = time ? time.split(':') : null;
    if (hours === '12') {
      hours = '00';
    }
    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours}:${minutes}`;
  };

  const getDate = (date) => {
    let d = new Date(date);
    let n = d.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });
    let t = d.toLocaleTimeString('en-US', { timeZone: "America/New_York" })
    let replase = n?.replace(new RegExp(',', 'g'), ' ')
    return `${replase} • ${convertTime12to24(t)}`
  }

  return (
    <Card key={index} className={post?.frontmatter?.tags?.find(d => d === 'premium') ? 'premium-blog' : 'blog'}
      onClick={() => router.push(`/blogs/${post.slug}`)}
      sx={{
        // maxWidth: 650,
        '&:hover': { background: '#f8f9fa' },
        // border: '1px solid transparent',
        cursor: 'pointer', p: '12px', borderRadius: '8px', boxShadow: 0, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', bgcolor: (post?.frontmatter?.tags?.find(d => d === 'premium') || (index === 0 || index === 1)) ? '#f8f9fa' : 'transparent'
      }}>
      <CardContent sx={{ px: { xs: 0, md: '16px', sm: '16px' }, py: '16px' }}>
        <Stack direction="row" spacing={1}>
          {post?.frontmatter?.tags?.map(d =>
            d && d === 'premium' ?
              <Chip key={getRandomStr(3)} label={d} size="small" sx={{ background: 'linear-gradient(to right, #2DA1EE, #174ea6)', color: '#fff', textTransform: 'capitalize' }} /> :
              <Chip key={getRandomStr(3)} label={d.replace(/-/g, " ")} size="small" sx={{ background: '#F0F7FF'/*'#E7EBF0'*/, color: '#174ea6'/*color: '#3E5060'*/, textTransform: 'capitalize', border: "1px solid", borderColor: '#C2E0FF' }} />)}
          {(index == 0 || index == 1) && !post?.frontmatter?.tags?.find(d => d === 'latest') && <Chip label={`Latest`} size="small" sx={{ background: '#E7EBF0', color: '#174ea6'/*color: '#3E5060'*/, }} />}
          <Chip label={`${post?.frontmatter?.read_time ?? readingTime(post?.frontmatter?.description)} read`} size="small" sx={{ background: 'transparent', color: '#3E5060', '& .MuiChip-label': { px: 0 } }} />
        </Stack>
        <Typography variant="h6" component="div" sx={{ mt: 1, fontWeight: 600, fontSize: { md: '1.5rem', sm: '1.2rem', xs: '1.2rem' }, '& a': { color: '#000', textDecoration: 'none' }, '& a:hover': { color: '#174ea6', textDecoration: 'underline' } }}>
          <Link href={`/blogs/${post.slug}`}>
            {post?.frontmatter?.title}
          </Link>
        </Typography>
        <Typography variant="body1" sx={{ mb: 1.5, fontSize: '.97rem' }} color="text.secondary">
          {post?.frontmatter?.description}
        </Typography>
      </CardContent>
      <Box component="div" sx={{ mx: 0 }}>
        <CardActions sx={{ px: { xs: 0, sm: 1, md: 1 } }}>
          <Box component="div" sx={{ display: 'flex', alignItems: 'center' }}>
            <Avatar
              alt={post?.frontmatter?.author}
              src="/"
              sx={{ width: 28, height: 28, border: '3px solid', borderColor: '#E7EBF0', backgroundColor: '#174ea6', color: '#fff', fontSize: '0.8125rem', fontWeight: 500, mx: { md: .5, sm: .5, xs: 0 } }}
            />
            <Typography variant="body2" component="div" sx={{ ml: .5, fontSize: '0.87rem', fontWeight: 600 }} color="text.color.white">
              {post?.frontmatter?.author}
            </Typography>
          </Box>
          <Typography variant="caption" sx={{ ml: 'auto', fontSize: '.8rem', }} color="#3E5060">
            {getDate(post?.frontmatter?.date)}
          </Typography>
          {/* <Button href={`/blogs/${post.slug}`} size="small" endIcon={<KeyboardArrowRightRoundedIcon fontSize="small" />} sx={{ textTransform: 'none', ml: 'auto', fontSize: '.8rem', fontWeight: 600 }}>Read more</Button> */}
        </CardActions>
      </Box>
    </Card>
  )
}
